import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/extensions

export type PlusAddButtonProps = {
  url: string;
  onClick?: () => void;
};

export const PlusAddButton: React.FC<PlusAddButtonProps> = ({
  url,
  onClick,
}) => {
  return (
    <Button
      component={Link}
      to={url}
      onClick={onClick}
      variant="contained"
      color='primary'
      type="button"
      sx={{
        minWidth: '42px',
        aspectRatio: '1',
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="5.43433"
          y="0.618652"
          width="2.54951"
          height="13"
          rx="1.27476"
          fill="#f1f1f1"
        />
        <rect
          x="13.2087"
          y="5.84399"
          width="2.54951"
          height="13"
          rx="1.27476"
          transform="rotate(90 13.2087 5.84399)"
          fill="#f1f1f1"
        />
      </svg>
    </Button>
  );
};
